$(document).on("touchstart", () => {
  $(".b-search-box__input:focus").blur();
});
